export default {
  id: "",
  username: "",
  password: "",
  device_id: "",
  type: "",
  venue_id: "",
  role: "",
  duration: 15,
  config: {
    destination: "",
    name: "",
    request_as: ""
  },
  customer_id: "",
  permissions: "",
  capabilities: "",
  registration_key: null,

}
